import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=fa2e5d2c&scoped=true"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"
import style0 from "./Error.vue?vue&type=style&index=0&id=fa2e5d2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2e5d2c",
  null
  
)

export default component.exports